import { render, staticRenderFns } from "./TimestampAgo.vue?vue&type=template&id=7f4734cf&scoped=true&"
import script from "./TimestampAgo.vue?vue&type=script&lang=ts&"
export * from "./TimestampAgo.vue?vue&type=script&lang=ts&"
import style0 from "./TimestampAgo.vue?vue&type=style&index=0&id=7f4734cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4734cf",
  null
  
)

export default component.exports